import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import className from 'classnames';
import { LegTypeProps, LocationProp } from '../../models';
import { FragmentBody, FieldHeaderPrisma } from '../FlightsManager/MobileFragments';
import { LocationUtils } from '../../utils';
import { ConnectedAirportSelectorDropdown } from './AirportSelectorDropdown';
import { ConnectedAirportSelectorInputMobile } from './AirportSelectorInputMobile';

export const AirportSelectorPrisma = ({
    activeProduct,
    title,
    setValue,
    sources,
    value,
    focus,
    fetchedLocations,
    departureOrArrival,
    errorMessage,
}) => {
    const initialStateWord = LocationUtils.getInputText(value);
    const [displayedWord, setDisplayedWord] = useState(initialStateWord);
    const [ownFocus, setOwnFocus] = useState(focus);
    const airportSelectorRef = useRef();
    const airportInputRef = useRef();

    const classNames = className({
        'prisma-input-group': true,
        'focused': ownFocus,
        'valid': !ownFocus && displayedWord.length > 0 && errorMessage,
        'invalid': !ownFocus && displayedWord.length > 0 && !!errorMessage,
    });

    const handleClickOutside = () => {
        setOwnFocus(false);
        if (!value) {
            setDisplayedWord('');
            setValue(undefined);
        }
    };

    const handleClick = (event) => {
        if (
            !airportInputRef.current.contains(event.target) &&
            !airportSelectorRef.current.contains(event.target) &&
            ownFocus
        ) {
            handleClickOutside();
        }
    };

    const onClickItem = (value) => {
        setDisplayedWord(LocationUtils.getInputText(value));
        setOwnFocus(false);
        setValue(value);
    };

    const onChangeInput = (text) => {
        setDisplayedWord(text);
        setValue(undefined);
    };

    const onFocusInput = () => setOwnFocus(true);

    useEffect(() => {
        setOwnFocus(focus);
    }, [focus]);

    useEffect(() => {
        document.addEventListener('touchend', handleClick);
        return () => document.removeEventListener('touchend', handleClick);
    }, [ownFocus, displayedWord, fetchedLocations, handleClick]);

    return (
        <>
            <FieldHeaderPrisma textKey={title} hasLocationInput>
                <div ref={airportInputRef} className={classNames}>
                    <ConnectedAirportSelectorInputMobile
                        focus={ownFocus}
                        departureOrArrival={departureOrArrival}
                        displayedWord={displayedWord}
                        onChangeInput={onChangeInput}
                        onFocusInput={onFocusInput}
                        errorMessage={errorMessage}
                    />
                </div>
            </FieldHeaderPrisma>
            <FragmentBody padding={false}>
                <div ref={airportSelectorRef}>
                    <ConnectedAirportSelectorDropdown
                        activeProduct={activeProduct}
                        displayedWord={displayedWord}
                        focus={ownFocus}
                        onClickItem={onClickItem}
                        sources={sources}
                        isFixedWidth
                        hasBoxStyle={false}
                        departureOrArrival={departureOrArrival}
                    />
                </div>
            </FragmentBody>
        </>
    );
};

AirportSelectorPrisma.propTypes = {
    fetchedLocations: PropTypes.object,
    title: PropTypes.string.isRequired,
    setValue: PropTypes.func.isRequired,
    sources: PropTypes.array.isRequired,
    value: LocationProp,
    focus: PropTypes.bool,
    departureOrArrival: LegTypeProps.isRequired,
    errorMessage: PropTypes.string,
};

AirportSelectorPrisma.defaultProps = {
    fetchedLocations: {},
    value: null,
    focus: false,
    errorMessage: '',
};

const mapStateToProps = ({ locationAutocomplete, activeProduct }) => ({
    fetchedLocations: locationAutocomplete.locations,
    activeProduct: activeProduct.activeProduct,
});

const connected = connect(mapStateToProps, {})(AirportSelectorPrisma);
export { connected as ConnectedAirportSelectorPrisma };
